// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Skills_contentWrapper__U54zJ"};